<div
  class="trigger-builder align-items-center d-flex flex-row p-2 rounded"
  [ngClass]="{ active: builderForm.dirty || !!!initValue }"
  [formGroup]="builderForm"
>
  <div class="flex-shrink me-4">
    <div *ngIf="!order && !isDisabled" class="sequence-indicator remove-add-indicator" (click)="remove()">
      <anduin-icon name="x" stroke="currentColor" />
    </div>
    <div *ngIf="order || isDisabled" class="sequence-indicator order-indicator">
      <div>{{ order || '' }}</div>
    </div>
  </div>
  <div class="flex-shrink-1 me-2">When an Invoice due date</div>
  <div class="me-2">
    <select class="form-select" formControlName="comparatorOperator">
      <option *ngFor="let option of OPERATOR_OPTIONS" [value]="option.value">
        {{ option.label }}
      </option>
    </select>
  </div>
  <div class="col-3 d-flex flex-row align-items-center">
    <div class="col-2 col-sm-4 me-2">
      <input
        type="number"
        class="form-input"
        [ngClass]="{ 'form-input--invalid': comparatorValueControl.invalid && comparatorValueControl.touched }"
        formControlName="comparatorValue"
      />
    </div>
    <div class="col d-flex flex-row align-items-center">
      <span class="align-middle">
        {{ comparatorOperator.value === '<=' ? 'days from now' : 'days ago' }}
      </span>
    </div>
  </div>
  <ng-container *ngIf="!!initValue && !isDisabled">
    <div *ngIf="builderForm.dirty" class="d-flex flex-row ms-auto">
      <button class="button button--text text--secondary" (click)="revertChanges()">Revert</button>
      <button class="button button--primary" (click)="save()">Update</button>
    </div>

    <div
      *ngIf="!builderForm.dirty"
      class="flex-shrink d-flex flex-row align-items-center ms-auto"
      [tooltipEnabled]="isOnlyTrigger()"
      tooltip="There must be at least one trigger present."
    >
      <button [disabled]="isOnlyTrigger()" (click)="remove()" andButton color="ghost-secondary">
        Remove
        <anduin-icon name="minus-circle" class="ms-2" fill="none" stroke="currentColor" />
      </button>
    </div>
  </ng-container>
  <div *ngIf="!!!initValue && !isDisabled" class="d-flex flex-row ms-auto">
    <button class="button button--primary" (click)="save()">Add</button>
  </div>
</div>
